'use client'

import { Product, ProductLangItem } from '@/eshop/gql/graphql'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import SubHeading from './SubHeading'

interface Props {
    product: Product
    info: ProductLangItem | undefined
}
export function TopProductDetailInfo({ product, info }: Props) {
    const { t } = useTranslation()

    return (
        <>
            <div className="mt-6">
                <div>
                    {t('eshop.productdetail.manufacturer')}{' '}
                    {info?.brandName || '---'}
                </div>
                <InfoRow label={info?.CFQuality || ''} />
            </div>
            <hr className="my-5" />
            <InfoRow
                className="mb-2"
                label={t('eshop.productdetail.CAS')}
                value={product.CAS}
            />
            <InfoRow
                className="mb-2"
                label={t('eshop.productdetail.EINECS')}
                value={product.EINECS}
            />
            <InfoRow
                className="mb-2"
                label={t('eshop.productdetail.MolWeight')}
                value={product.relMolWeight}
            />
            <InfoRow
                className="mb-2"
                label={t('eshop.productdetail.RTECS')}
                value={product.RTECS}
            />
            <InfoRow
                className="mb-2"
                label={t('eshop.productdetail.Synonym')}
                value={info?.synonymLang}
            />
        </>
    )
}

export function BottomProductDetailInfo({ product, info }: Props) {
    const { t } = useTranslation()

    return (
        <>
            <SubHeading>
                {t('eshop.productdetail.chemicalProperties')}
            </SubHeading>
            <InfoRow
                className="mb-2"
                label={t('eshop.productdetail.usability')}
                value={info?.usebilityLang}
            />
            <InfoRow
                className="mb-2"
                label={t('eshop.productdetail.meltingPoint')}
                value={product.productLangItems[0].meltingPoint}
            />
            <InfoRow
                className="mb-2"
                label={t('eshop.productdetail.boilingPoint')}
                value={product.productLangItems[0].boilingPoint}
            />
            <InfoRow
                className="mb-2"
                label={t('eshop.productdetail.appearance')}
                value={info?.appearanceLang}
            />
        </>
    )
}

export function InfoRow({
    label,
    value,
    className,
}: {
    className?: string
    label: string
    value?: string | null
}) {
    return (
        <div className={clsx('flex justify-between', className)}>
            <div className="w-1/3 flex-shrink-0">{label}</div>
            <div className="text-right">{value || ''}</div>
        </div>
    )
}
